// VERY IMPORTANT!
// Make sure you use descriptive names in the strings, otherwise there will be name clashes.
// In other words, we cannot re-use a name inside a string inside another redux component

export const AUTH_API_LOGIN_REQUEST = "AUTH_API_LOGIN_REQUEST",
  AUTH_API_LOGIN_SUCCESS = "AUTH_API_LOGIN_SUCCESS",
  AUTH_API_LOGIN_FAILURE = "AUTH_API_LOGIN_FAILURE",
  AUTH_API_LOGOUT_REQUEST = "AUTH_API_LOGOUT_REQUEST",
  AUTH_API_LOGOUT = "AUTH_API_LOGOUT",
  AUTH_API_REFRESH_ACCESS_TOKEN = "AUTH_API_REFRESH_ACCESS_TOKEN";
